import type { Props as ButtonProps } from '@sorare/core/src/atoms/buttons/Button';
import { FilterButton } from '@sorare/core/src/components/search/FilterButton';
import { useFiltersCount as useSearchFiltersCount } from '@sorare/core/src/contexts/graphql-search';

import { useFiltersCount } from '#src/search/FiltersManager/useFiltersCount.ts';

type ToggleFiltersManagerProps = {
  toggleFilters: () => void;
  color?: ButtonProps['color'];
  size?: ButtonProps['size'];
};

export const ToggleFiltersManager = ({
  toggleFilters,
  color,
  size,
}: ToggleFiltersManagerProps) => {
  const filtersCount = useFiltersCount({
    countSealed: false,
  });
  return (
    <FilterButton
      onClick={() => {
        toggleFilters();
      }}
      filtersCount={filtersCount}
      color={color}
      size={size}
    />
  );
};

export const BackendToggleFiltersManager = ({
  toggleFilters,
  color,
  size,
}: ToggleFiltersManagerProps) => {
  const filtersCount = useSearchFiltersCount();
  return (
    <FilterButton
      onClick={() => {
        toggleFilters();
      }}
      filtersCount={filtersCount}
      color={color}
      size={size}
    />
  );
};
